import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container, Sprite } from '@pixi/react';
import * as PIXI from 'pixi.js';
import { useCallback, useMemo } from 'react';
import { CHAT_BUBBLE_ANIMATION_SET } from '../../../animations/animationDefinitions';
import PLAYER_CHAT_BUBBLE_IMAGE_URL from '../../../assets/player-chat-bubble.png';
import { hideChatBubble } from '../../../redux/actions/pokerActions';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { isTestEnvironment } from '../../../utils/utils';
import { AnimationContainer } from '../pixiComponents/animationContainer';
const TEXTURE_SIZE_PX = 256;
const MAX_RENDER_SIZE_PX = 128;
const OPAQUE_TEXTURE_WIDTH_PX = 256;
const OPAQUE_TEXTURE_HEIGHT_PX = 213;
export const PlayerChatBubbleContainer = ({ seatIndex, seatBounds }) => {
    const startTimestampMs = useAppSelector((state) => state.poker.chatBubbles[seatIndex]?.startTimestampMs);
    const roughAvatarSizePx = useAppSelector((state) => state.gameDimensions.roughAvatarSizePx);
    const dispatch = useAppDispatch();
    const texture = useMemo(() => PIXI.Texture.from(PLAYER_CHAT_BUBBLE_IMAGE_URL), []);
    const onAnimationDone = useCallback(() => {
        dispatch(hideChatBubble(seatIndex));
    }, [dispatch, seatIndex]);
    if (startTimestampMs === undefined || roughAvatarSizePx === undefined) {
        return null;
    }
    const maxWidthPx = Math.min(MAX_RENDER_SIZE_PX, seatBounds.w / 2);
    const maxHeightPx = Math.min(MAX_RENDER_SIZE_PX, seatBounds.h / 2);
    const isHeightRestricted = maxWidthPx > maxHeightPx;
    const scale = isHeightRestricted ? maxHeightPx / TEXTURE_SIZE_PX : maxWidthPx / TEXTURE_SIZE_PX;
    const renderedWidthPx = scale * OPAQUE_TEXTURE_WIDTH_PX;
    const renderedHeightPx = scale * OPAQUE_TEXTURE_HEIGHT_PX;
    const maxX = seatBounds.w / 2 - renderedWidthPx / 2;
    const x = Math.min(maxX, roughAvatarSizePx / 2 - renderedWidthPx / 2);
    const minY = -seatBounds.h / 2 + renderedHeightPx / 2;
    const y = Math.max(minY, -roughAvatarSizePx / 2 + renderedHeightPx / 2);
    return (_jsx(Container, { interactiveChildren: false, scale: scale, x: x, y: y, "pixi-data": isTestEnvironment() ? { type: 'chat-bubble', seatIndex } : null, children: _jsx(AnimationContainer, { startTimestampMs: startTimestampMs, animationSet: CHAT_BUBBLE_ANIMATION_SET, onAnimationDone: onAnimationDone, children: _jsx(Sprite, { texture: texture, x: -TEXTURE_SIZE_PX / 2, y: -TEXTURE_SIZE_PX / 2 }) }) }));
};
